import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as DownloadIcon } from './download.svg';

export const Download = IconHOC(DownloadIcon);
